export default __webpack_public_path__ + "static/media/9.81bb3087.svg";